import { vars } from '@styles/vanilla-extract/theme.css';
import React from 'react';
import RatioSingleBarChart, {
	RatioSingleBarChartProps,
} from '@components/report/chart/ratio-single-bar-chart/RatioSingleBarChart';
import TriangleChart, {
	TriangleChartProps,
} from '@components/report/chart/triangle-chart/TriangleChart';
import ColoredSection from '@components/report/colored-section/ColoredSection';

import NineGridPicturesCard, {
	NineGridPicturesCardProps,
} from '@components/report/nine-grid-pictures-card/NineGridPicturesCard';
import ReportCard from '@components/report/report-card/ReportCard';

import { threeDivisionGridClass } from '@components/report/style.css';

import { containerClass, headContainerClass } from './style.css';

export interface ContentIgProps {
	bannerHashtags?: string[];
	contentType?: RatioSingleBarChartProps;
	nineGridPictures?: NineGridPicturesCardProps;
	averageFeedLike?: TriangleChartProps;
	averageFeedComment?: TriangleChartProps;
	averageVideoView?: TriangleChartProps;
	averageVideoLike?: TriangleChartProps;
	averageVideoComment?: TriangleChartProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const ContentIg = ({
	contentType,
	nineGridPictures,
	averageFeedLike,
	averageFeedComment,
	averageVideoView,
	averageVideoLike,
	averageVideoComment,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: ContentIgProps) => {
	const status = { isLoading, isError, lackOfPermission };

	const bannerHashtags =
		isLoading || isError
			? new Array(5).fill('-')
			: lackOfPermission
			? new Array(5).fill('example')
			: props.bannerHashtags && props.bannerHashtags.length > 0
			? props.bannerHashtags
			: '현재 데이터를 준비 중이거나 분석할 수 없는 상태';

	const isValidHashtags = Array.isArray(bannerHashtags) && bannerHashtags.length > 0;

	const bannerHashtagsString = isValidHashtags
		? bannerHashtags.map((item) => `#${item}`).join(', ')
		: bannerHashtags;

	return (
		<div className={containerClass}>
			<div className={headContainerClass}>
				<ColoredSection
					tooltip={
						'최근 24개의 콘텐츠(피드 및 동영상)를 기준으로 자주 사용된 해시태그 5개를 보여줍니다. 주요 해시태그 데이터는 인플루언서가 어떤 주제나 키워드에 집중하고 있는지 파악하는데 도움이 됩니다.'
					}
					{...status}
				>
					많이 사용된 주요 해시태그 5가지는{' '}
					{isValidHashtags ? <span>{bannerHashtagsString}</span> : bannerHashtagsString}
					입니다.
				</ColoredSection>

				<ReportCard
					label={'콘텐츠 유형'}
					tooltip={
						'최근 24개의 콘텐츠를 기준으로 피드와 동영상의 비율을 보여줍니다. 콘텐츠가 주로 어떤 형식으로 게시되는지 파악할 수 있습니다.'
					}
					lackOfPermission={lackOfPermission}
					height={180}
					align="horizontal"
				>
					<RatioSingleBarChart
						desc
						subDesc={'최근 콘텐츠 24개 기준'}
						items={[
							{
								label: '피드',
								value: '-%',
								color: vars.global.colors.primary[40],
							},
							{
								label: '동영상(릴스+비디오)',
								value: '-%',
								color: vars.global.colors.primary[60],
							},
						]}
						isLegend
						align="horizontal"
						{...contentType}
						{...status}
					/>
				</ReportCard>
			</div>

			<div className={threeDivisionGridClass}>
				<NineGridPicturesCard {...nineGridPictures} {...status} />

				<ReportCard
					label={'평균 피드 좋아요 수'}
					tooltip={
						'최근 24개의 콘텐츠 중 피드 콘텐츠를 기준으로 계산된 평균 좋아요 수입니다.'
					}
					height={296}
					lackOfPermission={lackOfPermission}
				>
					<TriangleChart desc {...averageFeedLike} {...status} />
				</ReportCard>

				<ReportCard
					label={'평균 피드 댓글 수'}
					tooltip={
						'최근 24개의 콘텐츠 중 피드 콘텐츠를 기준으로 계산된 평균 댓글 수입니다.'
					}
					height={296}
					lackOfPermission={lackOfPermission}
				>
					<TriangleChart desc {...averageFeedComment} {...status} />
				</ReportCard>

				<ReportCard
					label={'평균 동영상 조회 수'}
					tooltip={
						'최근 24개의 콘텐츠 중 동영상 콘텐츠를 기준으로 계산된 평균 조회 수입니다.'
					}
					height={296}
					lackOfPermission={lackOfPermission}
				>
					<TriangleChart desc {...averageVideoView} {...status} />
				</ReportCard>

				<ReportCard
					label={'평균 동영상 좋아요 수'}
					tooltip={
						'최근 24개의 콘텐츠 중 동영상 콘텐츠를 기준으로 계산된 평균 좋아요 수입니다.'
					}
					height={296}
					lackOfPermission={lackOfPermission}
				>
					<TriangleChart
						desc
						// valuePercentage={45}
						{...averageVideoLike}
						{...status}
					/>
				</ReportCard>

				<ReportCard
					label={'평균 동영상 댓글 수'}
					tooltip={
						'최근 24개의 콘텐츠 중 동영상 콘텐츠를 기준으로 계산된 평균 댓글 수입니다.'
					}
					height={296}
					lackOfPermission={lackOfPermission}
				>
					<TriangleChart
						desc
						// valuePercentage={45}
						{...averageVideoComment}
						{...status}
					/>
				</ReportCard>
			</div>
		</div>
	);
};

export default ContentIg;
